import PropTypes from "prop-types";
import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { isAnswered } from "../../../../utils/QuestionUtils";
import QuestionHeader from "./QuestionHeader";
import DateRenderer from "./renderer/DateRenderer";

/**
 * Date question component for survey-view.
 */
const DateQuestion = ({ disabled, question, questionAnswer, type, setQuestionAnswer }) => {
  return (
    <Row>
      <Col md={12}>
        <QuestionHeader question={question} answered={isAnswered(question, questionAnswer)}>
          <Row>
            <Col md={type === "text" ? 4 : 12} className="date-picker">
              <DateRenderer
                disabled={disabled}
                question={question}
                collection={questionAnswer.answers}
                setQuestionAnswer={setQuestionAnswer}
              />
            </Col>
          </Row>
        </QuestionHeader>
      </Col>
    </Row>
  );
};

DateQuestion.propTypes = {
  disabled: PropTypes.bool,
  question: PropTypes.object,
  questionAnswer: PropTypes.object,
  setQuestionAnswer: PropTypes.func,
  type: PropTypes.string
};

export default DateQuestion;
